import React, { useState, useRef } from "react";
import { useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import {
  AddBrandlogo,
  getAllBrandlogoData,
  getBrandlogoUpdate,
} from "../../api";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import { Toast } from "primereact/toast";
// import { setProfileData } from "../../redux/actions/profileAction";
import { SponsorSchema } from "../../schema";

let initialValues;

initialValues = {
  // ProfileDetails
  image: null,
  link: "",
};

const Sponsor = () => {
  //   const navigate = useNavigate();
  //   const dispatch = useDispatch();
  const { token } = useSelector((state) => state.profileReducer);
  const toast = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [previewImg, setPreviewImg] = useState(null);
  const [, setImage1] = useState();
  const [, setLink] = useState("");
  const [previewLink, setPreviewLink] = useState("");
  const [currentUserType, setCurrentUserType] = useState("");

  //   const [data, setData] = useState(null);
  const [id, setId] = useState(null);

  const handleLinkChange = (event) => {
    const newLink = event.target.value;
    setLink(newLink);
    setPreviewLink(newLink);
    setFieldValue("link", newLink);
  };

  const handleImageUpload = (event, setImage) => {
    const file = event.target.files[0];
    if (file) {
      setImage(file);
      setFieldValue("image", file);
    }
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        const convertImage = convertBase64ToImage(reader.result);
        setImage(convertImage);
        setPreviewImg(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const convertBase64ToImage = (uri) => {
    const splitDataURI = uri.split(",");
    const byteString =
      splitDataURI[0].indexOf("base64") >= 0
        ? atob(splitDataURI[1])
        : decodeURI(splitDataURI[1]);
    const type = splitDataURI[0].split(":")[1].split(";")[0];

    const ia = new Uint8Array(byteString.length);
    for (let i = 0; i < byteString.length; i += 1)
      ia[i] = byteString.charCodeAt(i);

    const imageBlob = new Blob([ia], { type });
    const imageFile = new File([imageBlob], "live-pic.jpeg", { type });

    return imageFile;
  };

  const onUserTypeChangeHandler = async (val) => {
    // setIsEdit(false);
    setCurrentUserType(val);
    getBrandLogo(val);
    // await getAllBrandlogoData(token, val).then((res) => {
    //   setPreviewImg(res?.data?.result[0]?.image);
    //   setPreviewLink(res?.data?.result[0]?.link);
    //   setFieldValue("image", res?.data?.result[0]?.image);
    //   setId(res?.data?.result[0]?.id);
    //   // setImage1(res?.data?.result[0].image);
    //   setIsLoading(false);
    // });
  };

  const getBrandLogo = async (type) => {
    setIsLoading(true);
    await getAllBrandlogoData(token, type).then((res) => {
      setPreviewImg(res?.data?.result[0]?.image);
      setPreviewLink(res?.data?.result[0]?.link);
      setFieldValue("image", res?.data?.result[0]?.image);
      setId(res?.data?.result[0]?.id);
      // setImage1(res?.data?.result[0]?.image);
      setIsLoading(false);
    });
  };

  const {
    values,
    errors,
    // handleChange,
    handleSubmit,
    touched,
    setFieldValue,
    // setFieldTouched,
    handleBlur,
  } = useFormik({
    initialValues,
    validationSchema: SponsorSchema(),
    onSubmit: (values, action) => onBrandLogoAdd(values, action),
  });

  const onBrandLogoAdd = async (values, action) => {
    const formData = new FormData();
    formData.append("brandLogo", values.image);
    formData.append("link", values.link);
    formData.append("type", currentUserType);
    if (id) {
      await getBrandlogoUpdate(id, formData, token)
        .then(async (res) => {
          setIsLoading(true);
          toast.current.show({
            severity: "success",
            summary: `${res?.data?.message}`,
          });
          await getBrandLogo(currentUserType);
          // action.resetForm();
          window.location.reload();
          setTimeout(() => {
            setIsLoading(false);
          }, 10000);
        })
        .catch((err) => {
          setIsLoading(false);
          toast.current.show({
            severity: "error",
            summary: `${err?.response?.data?.message}`,
          });
        });
    } else {
      await AddBrandlogo(formData, token)
        .then((res) => {
          setIsLoading(true);
          toast.current.show({
            severity: "success",
            summary: `${res?.data?.message}`,
          });
          action.resetForm();
          setTimeout(() => {
            setIsLoading(false);
            // getBrandLogo();
          }, 1000);
        })
        .catch((err) => {
          setIsLoading(false);
          toast.current.show({
            severity: "error",
            summary: `${err?.response?.data?.message}`,
          });
        });
    }
  };

  return (
    <>
      {isLoading && (
        <div className="set-proper-line-in-all-page">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}
      <Toast ref={toast} />
      <div className="content-section badges-section upload-user-profile-cls">
        <form onSubmit={handleSubmit} className="">
          <div className="specialities-tabbing">
            <h6>Sponsor</h6>
            <hr />
            <div className="row my-4">
              <div className="col-lg-4">
                <label className="my-2">Select Sponsor Type</label>
                <select
                  value={currentUserType}
                  className="form-select"
                  aria-label="Default select example"
                  // onBlur={handleBlur}
                  onChange={(e) => onUserTypeChangeHandler(e.target.value)}
                >
                  <option value="" disabled hidden>
                    Select Sponsor types
                  </option>
                  <option value="Super Loopers" label="Super Loopers"></option>
                  <option
                    value="The Loop Hall of Fame"
                    label="The Loop Hall of Fame"
                  ></option>
                  <option
                    value="The Loop Booth"
                    label="The Loop Booth"
                  ></option>
                </select>
                {/* {errors.user_type && touched.user_type ? (
                        <p className="form-error">{errors.user_type}</p>
                      ) : null} */}
              </div>
            </div>
            {currentUserType !== "" && (
              <>
                <div className="d-block mt-5">
                  <div className="upload-preview-containers">
                    <div className="row align-items-center">
                      <div className="col-lg-2 col-md-4 col-sm-4">
                        <div className="upload-buttons">
                          <h5 className="">
                            Brand Logo:{" "}
                            <span className="required">{"250w X 50h"}</span>
                          </h5>
                          <input
                            type="file"
                            name="image"
                            accept="image/png, image/jpeg, image/jpg"
                            className="btn btn-primary change-event-photo w-100 set-to-auto-height"
                            placeholder="File Name"
                            // value={values.image1}
                            onBlur={handleBlur}
                            onChange={(e) => handleImageUpload(e, setImage1)}
                          />
                          {errors.image && touched.image ? (
                            <p className="form-error">{errors.image}</p>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-lg-3">
                        <div className="image-preview2 mx-3">
                          {previewImg && (
                            <img src={previewImg} alt="Preview 1" />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row mt-4 align-items-center">
                  <div className="col-lg-2 col-md-4 col-sm-4">
                    <h5 className="my-2">Link</h5>
                    <input
                      type="link"
                      value={values.link}
                      onChange={handleLinkChange}
                      placeholder="Please Enter the Link Here"
                      className="form-control"
                      id="exampleFormControlInput2"
                      name="link"
                      onBlur={handleBlur}
                    ></input>
                    {errors.link && touched.link ? (
                      <p className="form-error">{errors.link}</p>
                    ) : null}
                  </div>
                  <div className="col-lg-2">
                    <div className="labeltexts-add">
                      <div>
                        <a
                          href={previewLink}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {previewLink}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-lg-1 mt-4">
                  <div className="add-btns-all-preview">
                    <button
                      type="submit"
                      className="btn btn-primary fill_btn border-0"
                      //   onClick={() => {
                      //     onBrandLogoAdd(values);
                      //   }}
                    >
                      Add
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
        </form>
      </div>
    </>
  );
};

export default Sponsor;
